export default __webpack_public_path__ + "static/media/icon-services.d7144698.svg";